// React
import React, { useState, useEffect, useContext, useRef } from "react";
// React
// CSS
import styles from "./Subject.module.css";
// CSS
// Services
import { getTeacherTeachItemsService } from "../../Services/Teachers/get/getTeacherTeachItemsService";
// Services
// Modules
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
// Modules
// Contexts
import { UserTokenContext } from "../../Contexts/userToken";
// Contexts
// Components
import LessonStatus from "./LessonStatus/LessonStatus";
import LessonCard from "./LessonCard/LessonCard";
import PendingManager from "../../Components/PendingManager/PendingManager";
// Components
// Models
import { I_TeachItem } from "../../Models/interfaces";
// Models
// Contexts
import { SetLessonDataContext } from "../../Contexts/SetLessonDataContext";
// Contexts
// Images
import { nodata, vidolist_watermark } from "../../Images/images";
import { _parser } from "../../Utils/_parser";
import { localStorageAvailabilityChecker } from "../../Utils/localStorageAvailabilityChecker";
import { SetAllDataNeededContext } from "../../Contexts/AllDataNeededContext";
// Images

const Subject = () => {
  // States
  const [teachItems, setTeachItems] = useState<I_TeachItem[]>([]);
  const [isPending, setIsPending] = useState<boolean>(true);
  // States
  // Constants
  const { teacherId, subjectId } = useParams();
  const userToken = useContext(UserTokenContext);
  const { state } = useLocation();
  const navigate = useNavigate();
  const setLessonData = useContext(SetLessonDataContext);
  const setAllNeededData = useContext(SetAllDataNeededContext);
  // Constants
  // refs

  const subjectIdRef = useRef<string | number | null>(
    _parser(localStorage.getItem("selectedSubject"))
  );
  // refs
  // LifeCycles
  useEffect(() => {
    console.log("state",state);
    if (!state) {
      navigate("/");
      return;
    } else {
      if (!setLessonData) return;
      if (!subjectIdRef.current) return;
      setLessonData((prevState) => ({
        ...prevState,
        subjectId: String(subjectIdRef.current || subjectId),
      }));
    }
  }, [navigate, state, setLessonData, subjectIdRef, subjectId]);
  //
  useEffect(() => {
    if (!subjectIdRef.current) return;
    getTeacherTeachItemsService(userToken, Number(subjectId), String(teacherId))
      .then(({ data: { data } }) => {
        console.log(data);
        setIsPending(false);
        setTeachItems(data);
      })
      .catch((err) => {
        console.log(err);
        Swal.fire({
          icon: "error",
          title: err?.response?.data?.message
            ? err?.response?.data?.message
            : err.message,
        });
        setIsPending(false);
      });
  }, [userToken, subjectIdRef, subjectId, teacherId]);
  //
  useEffect(() => {
    if (!state) {
      navigate("/");
      return;
    } else {
      const isLocalStorageAvailable = localStorageAvailabilityChecker();

      if (isLocalStorageAvailable) {
        if (!setLessonData) return;
        setLessonData((prevState) => {
          return {
            ...prevState,
            lessonId: _parser(localStorage.getItem("lessonId")),
            lessonName: String(
              _parser(localStorage.getItem("selectedSubject")).title
            ),
          };
        });
      }

      setAllNeededData((prevState) => ({
        ...prevState,
        teacherId: String(teacherId),
        teacherName: String(state.teacherName),
      }));
    }
  }, [setLessonData, setAllNeededData, state, teacherId, navigate]);
  // LifeCycles

  if (!state) {
    navigate("/");
    return <></>;
  }

  return (
    <div className={`${styles.teacherContainer} p-4 relative`}>
      <LessonStatus
        customData={state.title + " - " + state.teacherName}
        imageUrl={String(state.url)}
        subjectName={state.subjectName}
      />
      <div
        className={`${styles.lessonsContainer} px-4 mt-4 bg-white rounded-xl overflow-y-scroll relative flex items-center flex-col `}
      >
        <div className="relative z-20 w-full">
          <PendingManager
            data={
              <>
                {teachItems.length === 0 ? (
                  <img
                    src={nodata}
                    alt="nodataImg"
                    style={{
                      margin: "0 auto",
                    }}
                  />
                ) : (
                  teachItems.map((item) => (
                    <LessonCard
                      key={item.id}
                      data={item}
                      teacherName={String(state.teacherName)}
                      setTeachItems={setTeachItems}
                    />
                  ))
                )}
              </>
            }
            isPending={isPending}
          />
        </div>
        <img
          src={vidolist_watermark}
          className="w-10/12 opacity-40 fixed z-10 "
          alt=""
          style={{
            bottom: "10vh",
            width: window.innerWidth > 600 ? "590px" : "83%",
          }}
        />
      </div>
    </div>
  );
};

export default Subject;
